import { Link } from "react-router-dom";
import type { ArchiveItem } from "@/mocks/archive";

export default function ArchiveCard({ item, rank }: { item: ArchiveItem; rank?: number }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200 transition-all duration-300 hover:-translate-y-1 hover:ring-primary-300">
      <Link to={`/archives/${item.slug}`} className="relative block aspect-[4/5] w-full overflow-hidden">
        <img
          src={item.imgs[0]?.src}
          alt={item.imgs[0]?.alt || item.name}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-primary-700 backdrop-blur">
          {item.tag}
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-md bg-foreground-950/60 px-2 py-1 text-xs text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-accent-400" /> {item.heat}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4">
        {rank ? (
          <span className="font-heading text-2xl font-black text-accent-500">{String(rank).padStart(2, "0")}</span>
        ) : null}
        <h3 className="mt-1 font-heading text-lg font-bold leading-snug text-foreground-950">
          <Link to={`/archives/${item.slug}`} className="transition-colors hover:text-primary-600">
            {item.name}
          </Link>
        </h3>
        <p className="mt-0.5 text-sm font-medium text-primary-600">{item.role}</p>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">{item.summary}</p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1"><i className="ri-calendar-line" /> {item.day}</span>
          <span className="flex items-center gap-1"><i className="ri-eye-line" /> {item.views}</span>
        </div>
      </div>
    </article>
  );
}